import { Text } from "@certn/cascadia-react";
import { css } from "@emotion/css";

type Props = {
  testID?: string;
  children: React.ReactNode;
};

export function NavigationSubtitle(props: Props) {
  return (
    <div
      className={css({
        paddingBottom: "var(--space-3)",
        paddingLeft: "var(--space-2)",
      })}
      data-testid={props.testID ?? "navigation-subtitle"}
    >
      <Text style="global/label-small">{props.children}</Text>
    </div>
  );
}
